import { Dropdown, Input, Table } from "antd";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import svg27 from "../../../assets/svg/svg27.svg";
import DeleteModal from "../../../components/DeleteModal";
import NoDataTable from "../../../components/NoDataTable";
import InsideHeader from "../../../components/InsideHeader"; 
import { 
  fetchWalletUsers,
} from "../../../features/dropdown/dropdownSlice";
import WalletUserModal from "./modal/WalletUserModal";
import { timeAmPm } from "../../../utils";
import verifiedPng from "../../../assets/img/verified.png";
import svg66 from "../../../assets/svg/svg66.svg";

export default function WalletUserTable() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { walletUsers, loading, walletUsersCount, ndovuWallet } = useSelector(
    (state) => state.dropdown
  );
  const { staffloading } = useSelector((state) => state.staff); 
  const collectionWallet =
    ndovuWallet &&
    ndovuWallet?.find((item) => item?.walType === "DISBURSEMENT");

  const [searchText, setSearchText] = useState("");

   
  const [openUser, setopenUser] = useState(false);

  function handleCancelUser() {
    setopenUser(false);
  }

  const [open, setopen] = useState(false);

  function handleCancel() {
    setopen(false);
  }

  const [prodd, setProdd] = useState("");
  const [isModalOpenDelete, setIsModalOpenDelete] = useState(false);
  const showModalDelete = async () => {
    setIsModalOpenDelete(true);
  };

  const handleDelete = async () => {};

  const handleAdd = async () => {
    await setopenUser(true);
    await setProdd("");
  };

  const handleEdit = () => {
    setopenUser(true);
  };

  const settingItems = [
    {
      key: "1",
      label: (
        <Link
          onClick={handleEdit}
          className="flex  text-[16px] font-sans  !text-lightBlack"
        >
          Edit
        </Link>
      ),
    },
  ];
 
  const columns = [
    {
      title: "Email",
      dataIndex: "wuEmail",
      sorter: (a, b) => a.wuEmail.localeCompare(b.wuEmail),
    },
    {
      title: "Mobile Number",
      dataIndex: "wuMobileNumber",
      sorter: (a, b) => a.wuMobileNumber.localeCompare(b.wuMobileNumber),
    },
    {
      title: "User Type",
      dataIndex: "wuUserType",
      sorter: (a, b) => a.wuUserType.localeCompare(b.wuUserType),
    },
    {
      title: "Created Time",
      dataIndex: "createdDateTime",
      render:(item)=>{
        return(
            <div>{timeAmPm(item)}</div>
        )
      },
      sorter: (a, b) => a.createdDateTime.localeCompare(b.createdDateTime),
    },
    {
      title: "Email Status",
      dataIndex: "wuEnabled",
      render: (item) => {
        return (
          <div>
            {item == null || item == false ? (
            <img src={svg66} alt="svg66"/>
            ) : item == true ? (
              <img src={verifiedPng} alt="verifiedPng" />
            ) : null}
          </div>
        );
      }, 
    },
    
    {
      title: "Actions",
      render: (item) => (
        <>
          <Dropdown
            overlayStyle={{
              width: "250px",
            }}
            trigger={"click"}
            menu={{ items: settingItems }}
            placement="bottom"
          >
            <button onClick={() => setProdd(item)}>
              <img src={svg27} alt="svg27" />
            </button>
          </Dropdown>
        </>
      ),
    },
  ];

  const [pageIndex, setPageIndex] = useState(0);
  const [pageSize, setPageSize] = useState(10);

  async function fetchWalletUsersData(page, size) {
    dispatch(
      fetchWalletUsers({
        limit: size ?? pageSize,
        start: page ?? pageIndex,
      })
    );
  }

  useEffect(() => {
    fetchWalletUsersData();
  }, []);

  useEffect(()=>{
    dispatch(
      fetchWalletUsers({
          criteria: "Email",
          txtSearch: searchText,
        }))
  },[searchText])
  
  return (
    <div className="w-full h-full overflow-y-scroll">
      <InsideHeader
        title="Wallet User Information"
        subtitle="Manage wallet users within your institution"
        back={true}
        title1="Wallet Information"
        title2="Wallet Details"
      /> 
        <div className="bg-white rounded-[10px] mt-[1.25rem] h-full">
          <div className="flex flex-col w-full lg:px-10 px-3 ">
            <h3 className="font-[700] text-[24px] text-lightBlack dash-title mt-[1.25rem]">
              Wallet User Details
            </h3>
            <div className="mt-5 flex lg:flex-row flex-col gap-y-5 justify-between lg:items-center items-start w-full">
              <div className="flex items-center w-full ">
                <Input
                  value={searchText}
                  onChange={(e) => setSearchText(e.target.value)}
                  placeholder="Search wallet user name or keyword"
                  className="text-[16px] font-[400] flex-row-reverse search-input"
                  prefix={
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                    >
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M11.2508 3.75C7.50609 3.75 4.47041 6.93997 4.47041 10.875C4.47041 14.81 7.50609 18 11.2508 18C14.9955 18 18.0312 14.81 18.0312 10.875C18.0312 6.93997 14.9955 3.75 11.2508 3.75ZM3.04297 10.875C3.04297 6.11154 6.71773 2.25 11.2508 2.25C15.7838 2.25 19.4586 6.11154 19.4586 10.875C19.4586 15.6385 15.7838 19.5 11.2508 19.5C6.71773 19.5 3.04297 15.6385 3.04297 10.875Z"
                        fill="#333333"
                      />
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M16.045 15.913C16.3237 15.6201 16.7756 15.6201 17.0543 15.913L21.3902 20.4693C21.6689 20.7622 21.6689 21.237 21.3902 21.5299C21.1115 21.8228 20.6596 21.8228 20.3809 21.5299L16.045 16.9737C15.7663 16.6808 15.7663 16.2059 16.045 15.913Z"
                        fill="#333333"
                      />
                    </svg>
                  }
                />
              </div>
              <div className="flex lg:flex-row flex-col lg:items-center items-start lg:gap-x-10 gap-y-5">
                <div className="w-[229px]">
                  <button onClick={() => handleAdd()} className="cstm-btn">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="25"
                      height="24"
                      viewBox="0 0 25 24"
                      fill="none"
                    >
                      <path
                        d="M19.5 11H13.5V5C13.5 4.73478 13.3946 4.48043 13.2071 4.29289C13.0196 4.10536 12.7652 4 12.5 4C12.2348 4 11.9804 4.10536 11.7929 4.29289C11.6054 4.48043 11.5 4.73478 11.5 5V11H5.5C5.23478 11 4.98043 11.1054 4.79289 11.2929C4.60536 11.4804 4.5 11.7348 4.5 12C4.5 12.2652 4.60536 12.5196 4.79289 12.7071C4.98043 12.8946 5.23478 13 5.5 13H11.5V19C11.5 19.2652 11.6054 19.5196 11.7929 19.7071C11.9804 19.8946 12.2348 20 12.5 20C12.7652 20 13.0196 19.8946 13.2071 19.7071C13.3946 19.5196 13.5 19.2652 13.5 19V13H19.5C19.7652 13 20.0196 12.8946 20.2071 12.7071C20.3946 12.5196 20.5 12.2652 20.5 12C20.5 11.7348 20.3946 11.4804 20.2071 11.2929C20.0196 11.1054 19.7652 11 19.5 11Z"
                        fill="#FFCD47"
                      />
                    </svg>
                    <span className="ml-1">Add Wallet User</span>
                  </button>
                </div>
              </div>
            </div>
            <div className="dash-inner-page mt-[24px] max-w-full w-full overflow-x-auto">
              <section>
                <Table
                  rowSelection={false}
                  className="mt-[1.31rem] w-full"
                  scroll={{
                    x: 800,
                  }}
                  rowKey={(record) => record?.wuId}
                  columns={columns}
                  dataSource={walletUsers}
                  loading={loading}
                  pagination={{
                    position: ["bottomCenter"],
                    current: pageIndex + 1,
                    total: walletUsersCount,
                    pageSize: pageSize,
                    onChange: (page, size) => {
                      setPageIndex(page - 1);
                      setPageSize(size);
                      fetchWalletUsersData(page - 1, size);
                    },
                    showSizeChanger: false,
                    hideOnSinglePage: true,
                  }}
                />
              </section>
            </div>
          </div>
        </div>
      

      <DeleteModal
        isModalOpen={isModalOpenDelete}
        setIsModalOpen={setIsModalOpenDelete}
        prodd={prodd}
        handleDelete={handleDelete}
        loading={staffloading}
        content={`Are you sure you want to delete ${prodd?.jbnkBankName}?`}
        title={`Delete ${prodd?.jbnkBankName}`}
      />

      <WalletUserModal
        open={openUser}
        handleCancel={handleCancelUser}
        collectionWallet={collectionWallet}
        prodd={prodd}
        handleFetch={fetchWalletUsersData}
      />
    </div>
  );
}
